// extracted by mini-css-extract-plugin
export default {"main":"TwelvedataStatistics_main__ekoUC"};